/**
 * Line notes, read-only (#1156). The Pax8 slice owns the one notes store (#1123): a discount agreed, a reason, the next
 * step. The report shows the note with who and when, and links to the Licences screen to add or edit it.
 */
import type { LineNote } from '../../../lib/api/generated'
import { noteLabel } from './model'

export function NoteCell({ note, editHref }: { note: LineNote | undefined; editHref: string | null | undefined }) {
  const edit = editHref ? (
    <a href={editHref} className="text-2xs font-medium text-primary hover:underline">
      {note ? 'Edit on Licences' : 'Add on Licences'}
    </a>
  ) : null
  if (!note) return edit ?? <span className="text-xs text-muted-foreground">—</span>
  return (
    <div className="flex min-w-48 max-w-96 flex-col gap-0.5">
      <p className="rounded-md bg-muted px-2 py-1 text-xs whitespace-pre-wrap text-foreground">{note.text}</p>
      <span className="text-2xs text-muted-foreground">
        {noteLabel(note)}
        {edit ? <> · {edit}</> : null}
      </span>
    </div>
  )
}
